export default __webpack_public_path__ + "static/media/empty_measure.13fa425e.png";